import {Button, Form, Input, Popover, Select, Upload} from "antd";
import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import attachment from "../../../assets/images/attachment.svg";
import arrow from "../../../assets/images/button-arrow.svg";
import FirebaseKey from "../../../components/FirebaseKey/FirebaseKey";
import Loading from "../../../components/Loading/Loading";
import {FormValuesContact} from "../../../core/models/custom/formValuesContact";
import {FormValuesContactExtended} from "../../../core/models/custom/formValuesContactExtended";
import {UploadRequest} from "../../../core/models/requests/upload.request";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {upload, uploadReset} from "../../../core/services/miscService/upload/actions";
import {UploadState} from "../../../core/services/miscService/upload/types";
import {Helpers} from "../../../core/utilities/helpers";
import {IStore} from "../../../core/utilities/reducers";
import "./ContactForm.scss";

const {Option} = Select;

interface IProps {
  isLoading: boolean;
  callbackSubmit: (values: FormValuesContactExtended) => void;
  uploadState: UploadState;
  upload: (request: UploadRequest) => void;
  uploadReset: () => void;
}

const ContactForm = (props: IProps) => {
  const [subjects, setSubjects] = useState<string[]>([]);
  const [fileError, setFileError] = useState('');
  const [emailPopoverEligible, setEmailPopoverEligible] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setSubjects(FirebaseService.getContactUsSubjects());
    return () => props.uploadReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChangeEmail(e: React.ChangeEvent<HTMLInputElement>): void {
    const email: string = e.target.value;
    // eslint-disable-next-line
    const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isEmailError: boolean = true;
    if (email && emailRegexp.test(email)) {
      isEmailError = false;
    }
    setEmailPopoverEligible(false);
    setEmail(email);
    setEmailError(isEmailError);
  }

  function handleBeforeUpload(file: File): void {
    props.uploadReset();
    const isSizeOk = file.size / 1024 / 1024 < 2;
    if (isSizeOk) {
      props.upload({file});
      setFileError('');
    } else {
      setFileError('Dosya boyutu 2MB\'tan az olmalı!');
    }
  }

  function handleFinish(values: FormValuesContact): void {
    props.callbackSubmit({
      ...values,
      phone: Helpers.getMsisdnFromJwt() ?? '-',
      url: props.uploadState.data?.url,
    });
  }

  return (
    <Form
      form={form}
      id="contact-form"
      className="app-form"
      layout="vertical"
      onFinish={handleFinish}
    >
      <Form.Item
        name="name"
        label={<FirebaseKey firebaseKey={FirebaseService.contact_us_name}/>}
        required={false}
        rules={[{required: false, message: ''}]}
      >
        <Input/>
      </Form.Item>

      <Popover
        overlayClassName="email-popover"
        placement="topLeft"
        visible={submitted && emailPopoverEligible && emailError && email.trim().length > 0}
        content={
          <div className="popover">
            <FirebaseKey firebaseKey={FirebaseService.contact_us_invalid_email}/>
          </div>
        }
      >
        <div/>
      </Popover>

      <Form.Item
        name="email"
        label={<FirebaseKey firebaseKey={FirebaseService.contact_us_mail}/>}
        required={false}
        rules={[
          {required: true, message: !email ? FirebaseService.getValue(FirebaseService.contact_us_email_error) : ''},
          {type: 'email', message: ''},
        ]}
      >
        <Input type="email" onChange={e => handleChangeEmail(e)}/>
      </Form.Item>

      <Form.Item
        name="subject"
        rules={[{required: true, message: FirebaseService.getValue(FirebaseService.contact_us_subject_error)}]}
      >
        <Select
          placeholder={FirebaseService.getValue(FirebaseService.contact_us_subject)}
        >
          {subjects.map(subject => <Option key={subject} value={subject}>{subject}</Option>)}
        </Select>
      </Form.Item>

      <Form.Item
        name="body"
        rules={[{required: true, message: FirebaseService.getValue(FirebaseService.contact_us_message_error)}]}
      >
        <Input.TextArea
          className="text-area"
          rows={3}
          placeholder={FirebaseService.getValue(FirebaseService.contact_us_message)}
        />
      </Form.Item>

      <div className="d-flex justify-content-center mt-2">
        <Upload
          name="file"
          accept=".png,.jpg,.jpeg"
          fileList={[]}
          beforeUpload={(file) => {
            handleBeforeUpload(file);
            return false;
          }}
        >
          <Button
            className={`app-button upload ${!props.uploadState.loading && props.uploadState.data ? 'uploaded' : ''}`}
          >
            {
              props.uploadState.loading
                ? <Loading/>
                : <img src={attachment} alt="file"/>
            }
          </Button>
        </Upload>
        <Button
          htmlType="submit"
          className="app-button blue"
          disabled={props.isLoading}
          onClick={() => {
            setEmailPopoverEligible(true);
            setSubmitted(true);
          }}
        >
          <FirebaseKey firebaseKey={FirebaseService.contact_us_button}/>
          <img className="arrow" src={arrow} alt="arrow"/>
        </Button>
      </div>
      {
        fileError &&
        <div className="file-error">{fileError}</div>
      }
    </Form>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      upload,
      uploadReset,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    uploadState: store.upload,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
